import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import type { Google } from './types';

const GOOGLE_MAPS_VERSION = '3.59';

let googleMapsPromise: Promise<Google> | undefined;

// setOptions must only be called once per page, so the load is shared between all callers
export const loadGoogleMaps = (apiKey: string): Promise<Google> => {
  if (!googleMapsPromise) {
    setOptions({
      key: apiKey,
      v: GOOGLE_MAPS_VERSION,
      language: 'en-AU',
      region: 'AU',
      libraries: ['geometry', 'drawing'],
    });

    // The v2 loader no longer exposes every library on the google.maps namespace up front,
    // so load each one used by the app (map, event/LatLng, Marker, StreetView and geometry)
    googleMapsPromise = Promise.all([
      importLibrary('core'),
      importLibrary('maps'),
      importLibrary('marker'),
      importLibrary('streetView'),
      importLibrary('geometry'),
    ]).then(() => google);

    // allow a retry if loading failed (e.g. network error)
    googleMapsPromise.catch(() => {
      googleMapsPromise = undefined;
    });
  }

  return googleMapsPromise;
};
